import React from 'react';
import theme from '../style/theme';

interface IconProps {
  fillColor?: string;
}

const HashIcon: React.FC<IconProps> = ({
  fillColor = `${theme.colors.g3}`,
}) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.9193 1.696C8.02744 1.11925 7.64755 0.56403 7.0708 0.455889C6.49405 0.347748 5.93884 0.727632 5.83069 1.30438L5.09671 5.21894H2.625C2.0382 5.21894 1.5625 5.69464 1.5625 6.28144C1.5625 6.86825 2.0382 7.34394 2.625 7.34394H4.69828L3.80179 12.1252H1.5625C0.975697 12.1252 0.5 12.6009 0.5 13.1877C0.5 13.7745 0.975697 14.2502 1.5625 14.2502H3.40336L2.64319 18.3044C2.53505 18.8811 2.91494 19.4364 3.49169 19.5445C4.06844 19.6526 4.62366 19.2727 4.7318 18.696L5.56539 14.2502H10.8409L10.0807 18.3044C9.97255 18.8811 10.3524 19.4364 10.9292 19.5445C11.5059 19.6526 12.0612 19.2727 12.1693 18.696L13.0029 14.2502H15.375C15.9618 14.2502 16.4375 13.7745 16.4375 13.1877C16.4375 12.6009 15.9618 12.1252 15.375 12.1252H13.4013L14.2978 7.34394H16.4375C17.0243 7.34394 17.5 6.86825 17.5 6.28144C17.5 5.69464 17.0243 5.21894 16.4375 5.21894H14.6962L15.3568 1.696C15.4649 1.11925 15.0851 0.56403 14.5083 0.455889C13.9316 0.347748 13.3763 0.727632 13.2682 1.30438L12.5342 5.21894H7.25875L7.9193 1.696ZM11.2393 12.1252L12.1358 7.34394H6.86031L5.96382 12.1252H11.2393Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default HashIcon;
